import Vue from 'vue';
import TombolaBaseComponent from '@/components/base/base.component';
import { Component, Prop } from 'vue-property-decorator';
import { getPathToCallImagesFolder } from '@/components/game/_domain';
import { IGameController } from '@/components/game/_domain/models/game-controller';
import { IGame, IGameRepresentationChangedArgs } from '@/components/game/_domain/models';

@Component({
  name: 'ThemeDisplayComponent'
})
export default class ThemeDisplayComponent extends TombolaBaseComponent {
  @Prop() public gameController: IGameController;
  private theme: string = null;

  private mounted() {
    const game = this.gameController.getGame();

    Vue.nextTick(() => {
      this.gameController.onGameRepresentationChanged(this.handleGameRepresentationChanged);
    });
  }

  private handleGameRepresentationChanged(eventArgs: IGameRepresentationChangedArgs) {
    const gameRepresentation = eventArgs.currentGameRepresentation;
    this.theme = gameRepresentation.wordSearchSubTheme || 'No Theme';
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/wordsearch/_components/theme-display/theme-display.component.ts